import ApiService from '@/services/api.service.js';

export const MonitoringService =
{
    createReport: function (data)
    {
        return ApiService.post('/monitoring/create/report', data);
    },

    getReport: function (reportId)
    {
        return ApiService.get('/monitoring/report/' + reportId);
    },

    getApplicationReports: function (data)
    {
        return ApiService.post('/monitoring/reports', data);
    },

    getAwardedApplications: function (data)
    {
        return ApiService.post('/monitoring/applications', data);
    },

    getAwardedApplication: function (data)
    {
        return ApiService.post('/monitoring/application', data);
    },

    getFilters: function (data)
    {
        return ApiService.post('/monitoring/filters', data);
    },

    updateReport: function (data)
    {
        return ApiService.post('/monitoring/update/report', data);
    },

    updateMonitoring: function (data)
    {
        return ApiService.post('/monitoring/update', data);
    },

    updateReportStatus: function (data)
    {
        return ApiService.post('/monitoring/update/report/status', data);
    },

    removeReport: function (reportId)
    {
        return ApiService.delete('/monitoring/report/' + reportId);
    },
}

export default MonitoringService
